import { render } from "./PostsTab.vue?vue&type=template&id=1b2f66f6&scoped=true"
import script from "./PostsTab.vue?vue&type=script&lang=js"
export * from "./PostsTab.vue?vue&type=script&lang=js"

import "./PostsTab.vue?vue&type=style&index=0&id=1b2f66f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2f66f6"]])

export default __exports__